import { type IPromo } from '../../../../../types/promos';

export function isMortgageButtonAvailable(promoInfo: IPromo): boolean {
  const isPartner = promoInfo.bank?.isPartner || false;

  return isPartner || promoInfo.promoType === 'cianMortgage';
}
